export default class AuthUtil {
    static needLogoutCallback = () => { };
}